import * as React from 'react';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';

let resx = LocalizationService.getInstance();
let NextStep_text = resx.getLocalizedResource('NextStep_text');

interface INextStepViewProps {
  ProvideIssueDetailDiv?: JSX.Element;
  ContinueDiv?: JSX.Element;
  marginTop?: string;
  marginBottom?: string;
  padding?: string;
  fontWeight?: any;
}

interface INextStepViewState {}

// NextStepView is a view component that displays the next step block for topicsContainer and solutionView
export default class NextStepView extends React.Component<INextStepViewProps, INextStepViewState> {
  render() {
    let { ProvideIssueDetailDiv, ContinueDiv, marginTop, marginBottom, padding, fontWeight } = this.props;
    return (
      <div
        style={{
          marginTop: marginTop,
          marginBottom: marginBottom ? marginBottom : '24px',
          padding: padding ? padding : '20px 24px 0 24px',
        }}
      >
        <div style={{ fontSize: '18px', fontWeight: fontWeight ? fontWeight : 'bold', marginBottom: '15px' }}>
          {NextStep_text}
        </div>
        <div>
          <table>
            <tr>{ProvideIssueDetailDiv}</tr>
            <tr>{ContinueDiv}</tr>
          </table>
        </div>
      </div>
    );
  }
}
